import { Button } from '@civilgrid/ui/components';
import { DateTime } from 'luxon';
import { useForm } from 'react-hook-form';
import { updateDataRequestInvoice } from '~/api/civilsearch';
import { type DataRequestInvoice, type DataRequestV2, TransactionCategory } from '~/common/types';
import ControlledCheckbox from '~/components2/forms/controlled/ControlledCheckbox';
import ControlledDatePicker from '~/components2/forms/controlled/ControlledDatePicker';
import ControlledInput from '~/components2/forms/controlled/ControlledInput';
import Form from '~/components2/forms/Form';
import Input from '~/components2/forms/Input';
import { Notify } from '~/components2/Notify';

interface Props {
  request: DataRequestV2;
  invoice: DataRequestInvoice;
  onInvoiceSave: () => void;
}

export default function EditInvoice({ request, invoice, onInvoiceSave }: Props) {
  const { control, handleSubmit, formState } = useForm<DataRequestInvoice>({
    defaultValues: invoice,
  });

  const onSave = async (data: DataRequestInvoice) => {
    await updateDataRequestInvoice(request.id, data.id, data);
    Notify.info({ message: `Invoice saved - ${data.invoiceId}` });
    onInvoiceSave();
  };
  return (
    <div className="w-[400px] border p-2">
      <Form onSubmit={handleSubmit(onSave)} className="flex flex-col gap-1.5">
        <Input
          label="Unique Receipt Filename"
          tooltipText="date-project name-org name-data request id-project id--cg invoice id-agencyInvoiceId"
          value={`${DateTime.now().toFormat('yyyyMMdd')}-${request.requestId}-${
            request.project.projectId
          }-${request.project.name}-${
            (request.project.organization as any).name
          }-${formState.defaultValues?.invoiceId}-${formState.defaultValues?.agencyInvoiceId || ''}`}
          readOnly
          canCopy
          className="cursor-default"
        />
        <ControlledInput
          control={control}
          label="CG Invoice ID"
          name="invoiceId"
          readOnly
          canCopy
          className="cursor-default"
        />
        <ControlledInput control={control} label="Agency Invoice ID" name="agencyInvoiceId" canCopy />
        <ControlledInput control={control} label="Stripe ID" name="stripeId" canCopy />
        <ControlledInput control={control} label="Amount in CENTS" name="amount" type="number" />
        <div className="mt-2">
          <ControlledCheckbox control={control} label="Request fulfilled?" name="isRequestFulfilled" />
        </div>
        <ControlledDatePicker control={control} label="Request Fulfilled At" name="requestFulfilledAt" />

        <ControlledDatePicker control={control} label="Payment to Provider At" name="paymentToProviderAt" />
        <br />
        <div className="flex space-x-2">
          <Button
            variant="secondary"
            type="button"
            disabled={formState.isDirty}
            onClick={() => {
              const txnData = {
                projectId: request.project.id,
                amount: invoice.amount,
                description: `Map Request Fees - ${request.agency.agencyName}(${invoice.invoiceId})`,
                type: 'debit',
                category: TransactionCategory.UtilityMapRequest,
              };

              const url = `/admin/transactions?data=${encodeURIComponent(JSON.stringify(txnData))}`;

              window.open(url, '_blank');
            }}
          >
            Add txn to project for this invoice
          </Button>
          <Button disabled={!formState.isDirty} type="submit">
            Save
          </Button>
        </div>
      </Form>
    </div>
  );
}
